<template>
  <BtnDropdown
    v-if="Boolean(type)"
    class="tool-linking"
    :active="Boolean(type)"
    :title="'Linking'"
  >
    <template #button-content>
      <span><i class="far fa-link fs-16"></i></span>
    </template>

    <div style="width: max-content;">
      <div class="row -mx-gd-half">
        <div class="col-6 px-gd-half"><ToolLink /></div>
        <div class="col-6 px-gd-half"><ToolUnlink /></div>
      </div>
    </div>
  </BtnDropdown>
  <ToolLink v-else />
</template>

<script>
import { mapGetters } from "vuex";
import BtnDropdown from "./_BtnDropdown";
import ToolLink from "./Link";
import ToolUnlink from "./Unlink";

export default {
  components: {
    BtnDropdown,
    ToolLink,
    ToolUnlink,
  },
  computed: {
    ...mapGetters({
      languageEngine: "designIframe/userPreference/languageEngine",
      texteditor: "designIframe/texteditor/texteditor",
    }),
    selectionFormatMerge() {
      return this.texteditor.selectionFormatMerge;
    },
    type() {
      return this.selectionFormatMerge.linkType || 
        this.selectionFormatMerge.linkTypeOld || 
        (this.selectionFormatMerge.link && this.selectionFormatMerge.link.includes('http') && 'url') || 
        (this.selectionFormatMerge.link && this.selectionFormatMerge.link.includes('https') && 'url') || 
        (this.selectionFormatMerge.link && this.selectionFormatMerge.link.includes('mailto') && 'email') || 
        (this.selectionFormatMerge.link && this.selectionFormatMerge.link.includes('tel') && 'phone') ||
        (this.selectionFormatMerge.link && 'url') ||
        undefined;
    },
  },
}
</script>

<style>
/* .tool-linking .dropdown-menu.show {
  top: 100% !important;
} */
</style>